import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, LocaleX, NavX, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XButton, XImage, XText } from "IZOX/_X";
import { SysConfig } from "__SYSDefault/Config";
import { FaChevronDown } from "react-icons/fa";

/**
 * @augments {Component<Props, State>}
 */
class PageNav extends Component {

  static propTypes = {
    info: PropsType.object
  }

  static defaultProps = {
    info: {}
  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PageNav.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _toPage = (url) => {
    let {history} = this.props;
    if(url.startsWith("http")){
      NavX.NewWindow(url);
      return;
    }
    NavX.Goto(history, url);
  }

  renderBusinessHour(){
    let {info} = this.props;
    let {contactinfo} = info ?? {};
    let {businesshours} = contactinfo ?? {};
    return (
      <VStack>
        <HStack HAlign="[">
          <XImage source="/Images/home/logo.png"/>
        </HStack>
        <VStack fullWidth p={40} bgColor={ColorX.CSS("Grass")} HAlign="[">
          <XText color={ColorX.CSS("pureWhite")} fontSize={22} bold fullWidth textAlign="[">
            {LocaleX.Parse({
              EN: "Business Hours",
              TC: "營業時間"
            })}
          </XText>
          <XText color={ColorX.CSS("pureWhite")} fontSize={14}>
            {LocaleX.Parse(businesshours)}
          </XText>
        </VStack>
      </VStack>
    );
  }

  renderLink(caption, url){
    return (
      <XButton onPress={() => this._toPage(url)} padding={0}>
        <HStack>
          <XText color={ColorX.CSS("Stone")} fontSize={14}>
            {LocaleX.Parse(caption)}
          </XText>
        </HStack>
      </XButton>
    );
  }

  renderTitle(caption, url){
    if(url){
      return (
        <XButton onPress={() => this._toPage(url)} mB={16} padding={0}
          color={ColorX.CSS("Grass")} >
          <HStack>
            <XText fontSize={16} bold textAlign="[" fullWidth>
              {LocaleX.Parse(caption)}
            </XText>
          </HStack>
        </XButton>
      );
    }
    return (
      <HStack mB={16}>
        <XText color={ColorX.CSS("Grass")} fontSize={16} bold textAlign="[" fullWidth>
          {LocaleX.Parse(caption)}
        </XText>
      </HStack>
    );
  }

  renderService(){
    return (
      <VStack spacing={5} width={148} HAlign="[">
        {this.renderTitle({EN: "Service", TC: "服務"}, "Home#services")}
        {/* {this.renderLink({EN: "New Policy Application", TC: "新保單申請"}, "NewPolicyApply")}
        {this.renderLink({EN: "Policy Renewal", TC: "保單更新"}, "PolicyRenew")}
        {this.renderLink({EN: "View existing Policy", TC: "查看現有保單"}, "ExistPolicy")}
        {this.renderLink({EN: "Information Change Request", TC: "資料變更"}, "InfoChange")}
        {this.renderLink({EN: "Status checking for New Policy Application and Claim", TC: "新保單申請和索賠的狀態檢查"}, "PolicyStatus")}
        {this.renderLink({EN: "Report Generation", TC: "報告生成"}, "ReportGenerate")} */}
      </VStack>
    );
  }

  renderAboutUs(){
    return (
      <VStack spacing={5} width={148} HAlign="[">
        {this.renderTitle({EN: "About Us", TC: "關於我們"}, "Home#aboutus")}
      </VStack>
    );
  }

  renderPartner(){
    return (
      <VStack spacing={5} width={148} HAlign="[">
        {this.renderTitle({EN: "Partner", TC: "合作夥伴"})}
        {this.renderLink({EN: "CMB WING LUNG BANK LIMITED", TC: "招商永隆銀行"}, 
          "https://www.cmbwinglunginsurance.com/en/?gad_source=1&gclid=EAIaIQobChMI5aa3sJiVjAMVjAGtBh3cWjSdEAAYASAAEgLyx_D_BwE")}
      </VStack>
    );
  }

  renderGI(){
    return (
      <VStack spacing={5} width={260} HAlign="[">
        {this.renderTitle({EN: "General Insurance", TC: "一般保險"}, "GeneralInsurance")}
        {this.renderLink({
          EN: "Application Form for Change", 
          TC: "更改申請表"
        }, "GeneralInsurance")}
        {this.renderLink({
          EN: "Overseas Domestic Helpers Comprehensive Insurance Brochure", 
          TC: "海外家庭傭工綜合保險小冊子"
        }, "GeneralInsurance")}
        {this.renderLink({
          EN: "Office Comprehensive Insurance", 
          TC: "辦公室綜合保險"
        }, "GeneralInsurance")}
        {this.renderLink({
          EN: "Comprehensive Home Insurance", 
          TC: "綜合家居保險"
        }, "GeneralInsurance")}
        {this.renderLink({
          EN: "Fire insurance", 
          TC: "火災保險"
        }, "GeneralInsurance")}
        {this.renderLink({
          EN: "Car insurance", 
          TC: "汽車保險"
        }, "GeneralInsurance")}
      </VStack>
    );
  }

  renderTandC(){
    return (
      <VStack spacing={5} width={148} HAlign="[">
        {this.renderTitle({EN: "Terms and Conditions", TC: "條款及細則"}, "TandC")}
      </VStack>
    );
  }

  renderPages(){
    return (
      <HStack spacing={16} width={"auto"} fullHeight
        VAlign="^" HAlign="[">
        {this.renderService()}
        {this.renderAboutUs()}
        {this.renderPartner()}
        {this.renderGI()}
        {this.renderTandC()}
      </HStack>
    );
  }

  renderNormal(){
    return (
      <VStack mB={16}>
        <HStack spacing={124} VAlign="^" pT={24} pH={80} HAlign="["
          width={SysConfig.ContentWidth}>
          {this.renderBusinessHour()}
          {this.renderPages()}
        </HStack>
      </VStack>
    );
  }

  renderSeparator(){
    return (
      <VStack fullWidth>
        <HStack fullWidth bgColor={ColorX.CSS("Stone", 0.5)} height={1}/>
      </VStack>
    );
  }

  renderBusinessHourM(){
    let {info} = this.props;
    let {contactinfo} = info ?? {};
    let {businesshours} = contactinfo ?? {};
    return (
      <VStack fullWidth pH={20}>
        <VStack pH={20} pV={40} fullWidth bgColor={ColorX.CSS("Grass")} HAlign="[" spacing={10}>
          <XText color={ColorX.CSS("pureWhite")} fontSize={28} bold fullWidth textAlign="[">
            {LocaleX.Parse({
              EN: "Business Hours",
              TC: "營業時間"
            })}
          </XText>
          <XText color={ColorX.CSS("pureWhite")} fontSize={20}>
            {LocaleX.Parse(businesshours)}
          </XText>
        </VStack>
      </VStack>
    );
  }

  renderLinkM(caption, url){
    return (
      <XButton onPress={() => this._toPage(url)} padding={0}>
        <HStack>
          <XText color={ColorX.CSS("Stone")} fontSize={16}>
            {LocaleX.Parse(caption)}
          </XText>
        </HStack>
      </XButton>
    );
  }

  renderTitleM(caption, url, withArrow){
    if(url){
      return (
        <XButton onPress={() => this._toPage(url)} padding={0}
          color={ColorX.CSS("Grass")} fullWidth>
          <HStack>
            <XText fontSize={20} bold textAlign="[" fullWidth>
              {LocaleX.Parse(caption)}
            </XText>
            <Spacer/>
            {withArrow && <FaChevronDown size={20} color={ColorX.CSS("Grass")}/>}
          </HStack>
        </XButton>
      );
    }
    return (
      <HStack mB={16}>
        <XText color={ColorX.CSS("Grass")} fontSize={20} bold textAlign="[" fullWidth>
          {LocaleX.Parse(caption)}
        </XText>
        {withArrow && <FaChevronDown size={20} color={ColorX.CSS("Grass")}/>}
      </HStack>
    );
  }

  renderServiceM(){
    return (
      <VStack spacing={5} fullWidth HAlign="[">
        {this.renderTitleM({EN: "Service", TC: "服務"}, "Home#services")}
        {/* {this.renderLink({EN: "New Policy Application", TC: "新保單申請"}, "NewPolicyApply")}
        {this.renderLink({EN: "Policy Renewal", TC: "保單更新"}, "PolicyRenew")}
        {this.renderLink({EN: "View existing Policy", TC: "查看現有保單"}, "ExistPolicy")}
        {this.renderLink({EN: "Information Change Request", TC: "資料變更"}, "InfoChange")}
        {this.renderLink({EN: "Status checking for New Policy Application and Claim", TC: "新保單申請和索賠的狀態檢查"}, "PolicyStatus")}
        {this.renderLink({EN: "Report Generation", TC: "報告生成"}, "ReportGenerate")} */}
      </VStack>
    );
  }

  renderAboutUsM(){
    return (
      <VStack spacing={5} fullWidth HAlign="[">
        {this.renderTitleM({EN: "About Us", TC: "關於我們"}, "Home#aboutus")}
      </VStack>
    );
  }

  renderPartnerM(){
    return (
      <VStack spacing={5} fullWidth HAlign="[">
        {this.renderTitleM({EN: "Partner", TC: "合作夥伴"}, undefined, true)}
        {this.renderLinkM({EN: "CMB WING LUNG BANK LIMITED", TC: "招商永隆銀行"}, 
          "https://www.cmbwinglunginsurance.com/en/?gad_source=1&gclid=EAIaIQobChMI5aa3sJiVjAMVjAGtBh3cWjSdEAAYASAAEgLyx_D_BwE")}
      </VStack>
    );
  }

  renderGIM(){
    return (
      <VStack spacing={5} fullWidth HAlign="[">
        {this.renderTitleM({EN: "General Insurance", TC: "一般保險"}, "GeneralInsurance", true)}
        {this.renderLinkM({
          EN: "Application Form for Change", 
          TC: "更改申請表"
        }, "GeneralInsurance")}
        {this.renderLinkM({
          EN: "Overseas Domestic Helpers Comprehensive Insurance Brochure", 
          TC: "海外家庭傭工綜合保險小冊子"
        }, "GeneralInsurance")}
        {this.renderLinkM({
          EN: "Office Comprehensive Insurance", 
          TC: "辦公室綜合保險"
        }, "GeneralInsurance")}
        {this.renderLinkM({
          EN: "Comprehensive Home Insurance", 
          TC: "綜合家居保險"
        }, "GeneralInsurance")}
        {this.renderLinkM({
          EN: "Fire insurance", 
          TC: "火災保險"
        }, "GeneralInsurance")}
        {this.renderLinkM({
          EN: "Car insurance", 
          TC: "汽車保險"
        }, "GeneralInsurance")}
      </VStack>
    );
  }

  renderTandCM(){
    return (
      <VStack spacing={5} fullWidth HAlign="[">
        {this.renderTitleM({EN: "Terms and Conditions", TC: "條款及細則"}, "TandC")}
      </VStack>
    );
  }

  renderPagesM(){
    return (
      <VStack spacing={16} fullWidth pH={20} pV={30}
        VAlign="^" HAlign="[">
        {this.renderAboutUsM()}
        {this.renderSeparator()}
        {this.renderServiceM()}
        {this.renderSeparator()}
        {this.renderPartnerM()}
        {this.renderSeparator()}
        {this.renderGIM()}
        {this.renderSeparator()}
        {this.renderTandCM()}
      </VStack>
    );
  }

  renderMobile(){
    return (
      <VStack mV={36} fullWidth spacing={20}>
        <HStack HAlign="[" pH={20}>
          <XImage source="/Images/mutualins-logo-latest.png" width={window.innerWidth * 0.5}/>
        </HStack>
        {this.renderBusinessHourM()}
        {this.renderPagesM()}
      </VStack>
    );
  }

  render(){
    return ResponsiveX.Split({
      0: () => this.renderMobile(),
      [SysConfig.WebUIWidth]: () => this.renderNormal()
    });
  }

}

export default observer(PageNav);
